var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaceIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.757 13.771H12v2.932h1.757V24h3.609v-7.296h2.422s.227-1.406.337-2.943H17.38v-2.006c0-.3.393-.702.782-.702h1.967V8h-2.674c-3.787 0-3.698 2.935-3.698 3.374v2.397z",
    fill: "#898C96"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy43NTY4IDEzLjc3MUgxMlYxNi43MDMzSDEzLjc1NjhWMjRIMTcuMzY1OFYxNi43MDQzSDE5Ljc4NzZDMTkuNzg3NiAxNi43MDQzIDIwLjAxNDYgMTUuMjk4MiAyMC4xMjUxIDEzLjc2MDZIMTcuMzc5OFYxMS43NTUzQzE3LjM3OTggMTEuNDU1OCAxNy43NzI5IDExLjA1MzMgMTguMTYyNCAxMS4wNTMzSDIwLjEyOVY4SDE3LjQ1NDZDMTMuNjY4IDggMTMuNzU2OCAxMC45MzUyIDEzLjc1NjggMTEuMzczNlYxMy43NzFaIiBmaWxsPSIjODk4Qzk2Ii8+Cjwvc3ZnPgo=";
export { SvgFaceIco as ReactComponent };